export function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function riskBadgeClass(level: string): string {
  if (level === "高") return "bg-primary-100 text-primary-800 border-primary-300";
  if (level === "中") return "bg-accent-100 text-accent-900 border-accent-300";
  return "bg-secondary-100 text-secondary-800 border-secondary-300";
}

export function riskDotClass(level: string): string {
  if (level === "高") return "bg-primary-500";
  if (level === "中") return "bg-accent-500";
  return "bg-secondary-500";
}

export function categoryBadgeClass(key: string): string {
  switch (key) {
    case "quality":
      return "bg-primary-100 text-primary-800";
    case "service":
      return "bg-accent-100 text-accent-900";
    case "marketing":
      return "bg-secondary-100 text-secondary-800";
    default:
      return "bg-background-200 text-foreground-800";
  }
}